module.exports = {
  clientId: 147144,
  email: 'twiqa+pexpgrower1@climate.com',
  firstName: 'Jeff374',
  hybridUser: false,
  lastName: 'Grower1',
  userType: 'client',
  countryCode: 'BR',
};
